import styled from "styled-components";

export const AnnouncementBanner = styled.div`
  text-align: center;
  padding: var(--global-spacing-m) 0;
  background: var(--global-purple);
  color: #ffffff;

  &:hover {
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.2),
        rgba(255, 255, 255, 0.2)
      ),
      var(--global-purple);
  }
`;

export const BannerLink = styled.a`
  :hover {
    text-decoration: none;
  }
`;
